var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 8,
    fill: "#44546F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3568 14.97C37.1767 14.5741 36.8439 14.2645 36.4314 14.109C36.0189 13.9535 35.5603 13.9648 35.1562 14.1404L21.4898 20.0966H17.5C16.1926 20.0966 14.9373 20.5987 14.0029 21.4954C13.0685 22.392 12.5294 23.612 12.5012 24.8937C12.4729 26.1754 12.9577 27.417 13.8517 28.3525C14.7457 29.2879 15.9778 29.8428 17.2839 29.8982L20.8333 29.9014V35.6233H22.5V30.3429L35.1571 35.8595C35.4108 35.9699 35.6887 36.0165 35.9654 35.9948C36.2422 35.9732 36.509 35.8842 36.7418 35.7358C36.9745 35.5874 37.1658 35.3843 37.2982 35.145C37.4306 34.9058 37.5 34.6378 37.5 34.3656V15.6335C37.4996 15.405 37.4508 15.179 37.3568 14.97ZM17.347 28.2654C16.4771 28.2261 15.6575 27.8546 15.0633 27.2303C14.4691 26.6061 14.1477 25.7786 14.1677 24.9249C14.1877 24.0712 14.5475 23.259 15.1703 22.6621C15.793 22.0653 16.6292 21.731 17.5 21.731H20.8333V28.2686H17.5187L17.347 28.2654ZM35.8333 34.3656L22.5 28.5551V21.4449L35.8333 15.6335V34.3656Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard3);
export default __webpack_public_path__ + "static/media/card3.7430b9406b023aedcc0d2b97a4ed36e7.svg";
export { ForwardRef as ReactComponent };